<template>
	<div ref="tablePage" style="height: 100%">
		<!-- 面包屑导航 -->
		<div class="topNav">
			<div class="navFormWrapper">
				<el-breadcrumb separator-class="el-icon-arrow-right">
					<el-breadcrumb-item :to="{ path: '/homePage' }">首页</el-breadcrumb-item>
					<el-breadcrumb-item>车库管理</el-breadcrumb-item>
				</el-breadcrumb>
				<el-form ref="queryForm" :model="searchForm" inline label-width="88px" style="margin-left: 8vh">
					<el-form-item style="margin-bottom: 0" label="搜索小区:">
						<el-select v-model="state" placeholder="请选择" clearable size="small" filterable
							@change="handleSelect" @clear="clearInput">
							<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name"
								:value="item.xiaoqu_id" />
						</el-select>
					</el-form-item>
					<el-form-item style="margin-bottom: 0">
						<el-button icon="el-icon-refresh-left" type="warning" @click="clearInput2"
							size="small">重置</el-button>
						<el-button type="success" icon="el-icon-plus" @click="handleNewAdd"
							size="small">新增车库</el-button>
						<el-button type="info" icon="el-icon-upload2" @click="postTrue" size="small">导入车位图</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>



		<div class="card-container">
			{{ cardTitle }}
		</div>
		<el-table :data="tableList" style="width: 100%; margin-top: 2vh" border size="mini" :header-cell-style="{
        background: '#fff',
        height: '50px',
        color: '#909399',
        fontSize: '16px',
        fontFamily: 'Arial, sans-serif',
      }">
			<el-table-column prop="sort" label="排序" align="center" />
			<el-table-column prop="xiaoqu_name" label="所在小区" align="center" />
			<el-table-column prop="title" label="车库名称" align="center" />
			<el-table-column prop="title" label="车库图片" align="center">
				<template slot-scope="scope">
					<el-image :src="scope.row.carpark_img" :preview-src-list="[scope.row.carpark_img]"
						style="width: 50px; height: 50px"></el-image>
				</template>
			</el-table-column>
			<el-table-column prop="total_num" label="车位总数" align="center" />
			<el-table-column fixed="right" label="操作" align="center" width="420">
				<template slot-scope="scope">
					<el-button @click.native.prevent="handCar(scope.row)" type="info" size="small">
						车位管理
					</el-button>
					<el-button @click.native.prevent="updateMsg(scope.row)" type="primary" size="small"
						icon="el-icon-edit">
						修改
					</el-button>
					<el-button @click.native.prevent="singleDel(scope.row, scope.row.id)" type="danger" size="small"
						icon="el-icon-delete">
						移除
					</el-button>
					<el-button @click.native.prevent="drawFloorPic(scope.row)" type="warning" size="small"
						icon="el-icon-edit">
						绘制
					</el-button>
				</template>
			</el-table-column>
		</el-table>
		<pagination v-show="total > 0" :total="total" :page.sync="searchForm.page" :limit.sync="searchForm.pageSize"
			@pagination="initList" />
		<el-dialog :visible.sync="dialogVisible" title="地下车库信息" :before-close="getout" @close="handleClose"
			:lock-scroll="false" :append-to-body="true" width="65%" style="margin-top: -10vh"
			:close-on-click-modal="false">
			<el-button type="primary" icon="el-icon-plus" class="add-tab-button" @click="addFloor" size="mini" plain
				style="margin-bottom: 1vh">添加新楼层</el-button>
			<el-tabs v-model="tabPick" type="card" closable @tab-remove="removeTab" @tab-click="tabsClick">
				<el-tab-pane label="车库详情" name="carList">
					<el-form ref="dialogData" :model="dialogData" label-width="80px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="所在小区" required>
									<el-select v-model="dialogData.xiaoqu_id" placeholder="请选择" filterable clearable
										style="width: 100%">
										<el-option v-for="item in regionList" :key="item.id" :label="item.title"
											:value="item.id" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="车库名称" required>
									<el-input v-model="dialogData.title" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="车位总数">
									<el-input v-model="dialogData.total_num" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="排序">
									<el-input v-model="dialogData.sort" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="备注">
									<el-input type="textarea" :rows="2" v-model="dialogData.content" autocomplete="off"
										placeholder="请输入" />
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="8">
								<el-form-item label="车库图片" prop="image" required>
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image :preview-src-list="[imageUrl]" v-if="imageUrl" :src="imageUrl"
												class="avatar" />
											<i v-if="imageUrl" class="el-icon-close" @click.stop="removePic"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<div style="color: #999; margin-top: -1vh">
										图片大小建议400*300
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="16">
								<el-form-item label="图片地址">
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg()">选择图片</el-button>
										<el-input v-model="imageUrl" autocomplete="off" placeholder="请输入" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</el-tab-pane>

				<!-- 动态选项卡内容 -->
				<el-tab-pane v-for="floor in dialogData.floors" :label="floor.title" :name="
            dialogType == 'add' ? String(floor.id) : String(floor.floor_id)
          " :key="dialogType == 'add' ? floor.id : floor.floor_id">
					<el-form ref="dialogData" :model="floor" label-width="80px">
						<el-row>
							<el-col :span="12">
								<el-form-item label="名称" required>
									<el-input v-model="floor.title" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="排序">
									<el-input v-model="floor.sort" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-form-item label="vr链接">
									<el-input v-model="floor.vr_url" autocomplete="off" placeholder="请输入" />
								</el-form-item>
							</el-col>
							<el-col :span="12" v-if="dialogType == 'edit'">
								<el-row>
									<el-col :span="12">
										<el-form-item label="锁定">
											<el-switch v-model="floor.lock_btn_show" :active-value="1"
												:inactive-value="0" @change="changeStatus"></el-switch>
										</el-form-item>
									</el-col>
									<el-col :span="12">
										<el-form-item label="咨询类型" required>
											<el-select v-if="askTypeList && askTypeList.length"
												v-model="floor.ask_type">
												<el-option v-for="item in askTypeList" :key="item.key"
													:label="item.value" :value="item.key">
												</el-option>
											</el-select>
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
							<el-col :span="12">
								<el-form-item label="车库源图" prop="image">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleFirstSuccess(floor)" :before-upload="beforeAvatarUploads"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="floor.source_image" :src="floor.source_image"
												:preview-src-list="[floor.source_image]" class="avatar" />
											<i v-if="floor.source_image" class="el-icon-close"
												@click.stop="removeFirstThumb(floor)"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<div class="chooseImg">
										<el-button type="info" @click="chooseFirstimg(floor)">选择图片</el-button>
										<el-input v-model="floor.source_image" autocomplete="off"
											placeholder="请输入图片地址" />
									</div>
								</el-form-item>
							</el-col>
							<el-col :span="12">
								<el-row>
									<el-col :span="12">
										<el-form-item label="显示收藏">
											<el-switch v-model="floor.show_sc_count" :active-value="1"
												:inactive-value="0" @change="changeStatus"></el-switch>
										</el-form-item>
									</el-col>
								</el-row>
							</el-col>
							<el-col :span="24">
								<el-form-item label="车库图片" prop="image">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleFloorSuccess(floor)" :before-upload="beforeAvatarUpload"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="floor.thumb" :src="floor.thumb + '?t=' + new Date().getTime()"
												:preview-src-list="[floor.thumb + '?t=' + new Date().getTime()]" class="avatar" />
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<div class="chooseImg">
										<el-input disabled v-model="floor.thumb" autocomplete="off"
											placeholder="请输入图片地址" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="24">
								<el-form-item label="车库缩略图" prop="image" label-width="120">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleMinSuccess(floor)" :before-upload="beforeAvatarUploads"
										:headers="headers" :disabled="true">
										<div class="avatar-wrapper">
											<el-image v-if="floor.thumbnail" :src="floor.thumbnail"
												:preview-src-list="[floor.thumbnail]" class="avatar" />
											<i v-if="floor.thumbnail" class="el-icon-close"
												@click.stop="removeMinThumb(floor)"></i>
											<i v-else class="el-icon-picture-outline avatar-uploader-icon"
												@click="uploadPicIcon"></i>
										</div>
									</el-upload>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg4(floor)"
											style="margin-left: 8vh">选择图片</el-button>
										<el-input v-model="floor.thumbnail" autocomplete="off" placeholder="请输入图片地址" />
									</div>
								</el-form-item>
							</el-col>
						</el-row>
						<!--  车位类型 -->
						<el-row v-for="(carType, index) in floor.color_tip" :key="index">
							<el-col :span="2">
								<el-form-item label="车位类型" required>
									<el-color-picker v-model="carType.color" @change=""></el-color-picker>
								</el-form-item>
							</el-col>
							<el-col :span="14">
								<el-form-item>
									<el-select v-model="carType.title" placeholder="请选择类型"
										@change="colorChange(carType)" style="width: 100%">
										<el-option v-for="(item, index) in colorArr" :key="index" :label="item.name"
											:value="item.name" />
									</el-select>
								</el-form-item>
							</el-col>
							<el-col :span="2">
								<el-form-item>
									<el-button @click="removeItem(floor, index)" type="danger" icon="el-icon-delete"
										size="mini">删除</el-button>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="2">
								<el-form-item label="非在售车位颜色">
									<el-color-picker v-model="floor.no_sale_carport_color"></el-color-picker>
								</el-form-item>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="2">
								<el-form-item>
									<el-button @click="addCarType(floor)" type="primary" size="mini">添加车位类型</el-button>
								</el-form-item>
							</el-col>
						</el-row>
						<!-- 添加分区 -->
						<el-divider></el-divider>
						<el-row v-for="(area, index) in floor.areas" :key="index + 100">
							<el-col :span="8">
								<el-form-item label="分区" required>
									<el-input v-model="area.title" placeholder="请输入分区名"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="8">
								<el-form-item label="排序">
									<el-input v-model="area.sort" placeholder="请输入排序值"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="2">
								<el-form-item>
									<el-button @click="deleteArea(floor, index, area)" type="danger"
										icon="el-icon-delete" size="mini">删除</el-button>
								</el-form-item>
							</el-col>
							<el-col :span="24">
								<el-form-item label="分区图片" prop="image">
									<el-upload class="avatar-uploader" :action="uploadImgUrl" :show-file-list="false"
										:on-success="handleRegionSuccess(area)" :before-upload="beforeAvatarUploads"
										:headers="headers" :disabled="area.img ? true : false">
										<div class="avatar-wrapper">
											<el-image :preview-src-list="[area.img]" v-if="area.img" :src="area.img"
												class="avatar" />
											<i v-if="area.img" class="el-icon-close"
												@click.stop="removeArea(floor, index, area)"></i>
											<i v-else class="el-icon-plus avatar-uploader-icon"></i>
										</div>
									</el-upload>
									<div class="chooseImg">
										<el-button type="info" @click="chooseImg3(area)">选择图片</el-button>
										<el-input v-model="area.img" autocomplete="off" placeholder="请输入图片地址" />
									</div>
								</el-form-item>
								<el-divider></el-divider>
							</el-col>
						</el-row>
						<el-row>
							<el-col :span="2">
								<el-form-item>
									<el-button @click="addArea(floor)" type="primary" size="mini">添加分区</el-button>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>

					<!-- 动态渲染的选项卡内容 -->
				</el-tab-pane>
			</el-tabs>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitForms">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="选择绘制楼层" :visible.sync="drawFloor" :close-on-click-modal="false" width="30%"
			class="dialogHeight global-dialog-position drawDialog" style="margin-top: -7vh">
			<el-form ref="drawFloorForm" :model="drawFloorForm" label-width="80px">
				<el-col :span="24">
					<el-form-item label="绘制">
						<el-select v-model="drawFloorForm.floor_id" placeholder="请选择绘制楼层" style="width: 100%">
							<el-option v-for="(item, index) in floorArr" :key="index" :label="item.title"
								:value="item.id" />
						</el-select>
					</el-form-item>
				</el-col>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="drawSubmit">确 定</el-button>
				<el-button @click="getout">取 消</el-button>
			</div>
		</el-dialog>
		<el-dialog title="图片" :visible.sync="upImg" :close-on-click-modal="false" width="85%"
			class="dialogHeight global-dialog-position" style="margin-top: -7vh">
			<imgUpload ref="imgUpload" />
			<div slot="footer" class="dialog-footer">
				<el-button type="primary" @click="submitFormz">确 定</el-button>
			</div>
			<div slot="body" style="height: 50vh"></div>
		</el-dialog>


		<!-- 导入车位图弹窗 -->
		<el-dialog title="导入车位图" :visible.sync="importOpen" :close-on-click-modal="false" width="40%"
			class="global-dialog-position" :before-close="getouts" style="margin-top: -10vh">
			<el-select v-model="uploadXiaoquId" style="width: 100%;" placeholder="请选择" clearable size="small" filterable
				@change="uploadXiaoquHandleSelect" @clear="clearInput3">
				<el-option v-for="item in regionArr" :key="item.id" :label="item.xiaoqu_name" :value="item.xiaoqu_id" />
			</el-select>
			<el-upload class="upload-container" ref="upload" v-loading="diaIf" element-loading-text="上传中..." drag
				:show-file-list="false" :auto-upload="false" :action="uploadCheWeiUrl" :data="{xiaoquId:uploadXiaoquId}"
				:on-success="handleSuccess" :on-error="handleError" :headers="headers">
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件拖到此处，或<em>点击上传</em>
				</div>
			</el-upload>
			<el-button style="width: 100%; height: 60px;" size="small" type="success"
				@click="submitUpload">上传到服务器</el-button>
		</el-dialog>
	</div>
</template>
<script>
	import tableCommon from "../../../mixins/table-common";
	// 引入列表js
	import {
		getcarList,
		getFloor,
		editCarList,
		deleteCar,
		deletearea,
		deletefloor,
		drawPic,
		getAskTypeList,
		getCaportTypeList,
	} from "../../api/garage";
	import {
		getcommunityList
	} from "../../api/community";
	import {
		getCookie
	} from "../../utils/util";
	import imgUpload from "../../components/uploadImg.vue";

	import Vue from "vue";
	export default {
		mixins: [tableCommon],
		components: {
			imgUpload,
		},
		data() {
			return {
				drawFloorForm: {},
				upImg: false,
				// 请求
				api: {
					list: getcarList,
					del: deleteCar,
				},
				// 小区id
				regionArr: [],
				// 绘制楼层
				drawFloor: false,
				// 导入车位图弹窗显示
				importOpen: false,
				state: "",
				// 查询参数
				searchForm: {
					page: 1,
					pageSize: 15,
					xiaoqu_id: null,
				},
				// 校验规则
				rules: {
					xiaoqu_id: [{
						required: true,
						message: "请选择",
						trigger: "change"
					}],
					title: [{
						required: true,
						message: "请输入",
						trigger: "blur"
					}],
				},
				// 表格列表
				tableList: [],
				// 弹窗数据
				dialogData: {
					xiaoqu_id: '',
					floors: [],
				},
				// 弹窗显隐
				dialogVisible: false,
				// 选项卡选中
				tabPick: 0,
				// 弹窗类型
				dialogType: "",
				// 小区数组
				regionList: [],
				// 上传头文件
				headers: {
					Authorization: "Bearer " + getCookie("logintoken"),
				},
				imageUrl: "",
				floorImageUrl: "",
				// 图片上传地址
				uploadImgUrl: process.env.VUE_APP_URL + "/admin/uploadFile",
				// 车位图片上传
				uploadCheWeiUrl: process.env.VUE_APP_URL + "/admin/uploadFile/package",
				// 卡片标题
				cardTitle: "",
				// 图片预览
				imgDis: false,
				imgDis2: false,
				imgIf: false,
				imgIf1: false,
				imgIf2: false,
				imgIf3: false,
				imgIf4: false,
				setImageUrl: "",
				savedSetImageUrl: "",
				imgRes: "",
				imgRes2: "",
				imgRes3: "",
				imgRes4: "",
				// 楼层刷新数据
				floorRefeshData: "",
				// 绑定id
				modelId: "",
				// 绘图标识
				drawType: false,
				floorArr: [],
				// 颜色数组
				colorArr: [],
				diaIf: false,
				askTypeList: [],
				uploadXiaoquId: null,
			};
		},
		mounted() {
			this.getcommunityLists();
			const form = {
				select: 1,
			};
			getcarList(form).then((res) => {
				this.regionArr = res.data.records.filter((item, index, self) => {
					return self.findIndex((t) => t.xiaoqu_id === item.xiaoqu_id) === index;
				});
				console.log(this.regionArr)
				if (this.$route.query.id) {
					this.$nextTick(() => {
						Vue.set(this.searchForm, "xiaoqu_id", Number(this.$route.query
							.id)); // 使用Vue.set强制更新对象属性
						this.searchChange();
						// 在regionArr中找到id等于xiaoqu_id的相同项
						const selectedOption = this.regionArr.find(
							(item) => item.xiaoqu_id === this.searchForm.xiaoqu_id
						);
						console.log(selectedOption);
						this.cardTitle = selectedOption.city_name;
						// 输出相同项
					});
				}
			});
			getAskTypeList().then((res) => {
				if (res.code == 200 && res.data && res.data.length) {
					res.data.forEach((item) => {
						item.key = parseInt(item.key)
					})
					this.askTypeList = res.data
				}
			});
			
		},
		watch: {
			upImg(newVal) {
				if (newVal) {
					this.$nextTick(() => {
						this.$refs.imgUpload.resetSelect();
					});
				}
			},
			"dialogData.xiaoqu_id": function(newVal, oldVal) {
				if (newVal) {
					getCaportTypeList({
						xiaoqu_id: newVal
					}).then((res) => {
						if (res.code == 200 && res.data) {
							Object.keys(res.data).forEach((key) => {
								const colorTip = {
									name: key,
									color: res.data[key]
								};
								this.colorArr.push(colorTip);
							});
						}
					});
				}
			}
		},
		methods: {
			submitUpload() {
				console.log('=====================:', this.$refs.upload)
				if (this.uploadXiaoquId) {
					this.$refs.upload.submit();
				} else {
					this.$message.warning("请选择小区");
				}
			},
			uploadPicIcon() {
				this.$message.warning("请点击下方选择图片按钮进行上传");
			},
			// 导入车位图按钮点击
			postTrue() {
				this.importOpen = true;
			},
			// 关闭导入导出
			getouts() {
				this.importOpen = false;
			},
			// 上传成功
			handlefloorSuccess() {
				this.$message.success("导入成功");
				this.diaIf = false;
				this.importOpen = false;
			},
			handleSuccess(res, file, fileList) {
				// 处理上传成功的逻辑，可以在这里更新文件状态等  
				if (res.code == 200) {
					if (res.data && res.data.code != 200) {
						this.$message({
							type: 'error',
							message: res.data.msg,
							duration: 5000
						});
						return;
					}
					this.$message.success("上传成功");
				} else {
					this.$message.error('上传失败');
				}
			},
			handleError(err, file, fileList) {
				// 处理上传失败的逻辑，可以在这里更新文件状态等  
				console.log('handleError')
				this.$message.error('上传失败')
			},


			// 绘制确定
			async drawSubmit() {
				console.log(this.drawFloorForm);
				await this.drawPics(this.drawFloorForm);
			},
			// 绘制楼层
			drawFloorPic(res) {
				this.drawFloorForm = {};
				this.drawFloor = true;
				getFloor(res.id).then((req) => {
					this.floorArr = req.data.floor;
					console.log(this.floorArr);
				});
			},
			// 选项卡点击事件
			tabsClick(res) {
				// 将绑定name取出
				this.modelId = res._props.name;
				// if(this.modelId)
			},
			// 绘图
			drawPics(req) {
				this.drawType = true;
				const forms = {
					floor_id: req.floor_id,
				};
				drawPic(forms).then((res) => {
					if (res.code !== 200) return this.$message.error("操作失败!");
					this.$message.success("绘制成功");
					this.drawFloor = false;
				});
			},
			// 改变状态
			changeStatus() {
				editCarList(this.dialogData).then((res) => {
					if (res.code !== 200) return this.$message.error("操作失败!");
					this.$message.success("操作成功");
					this.initList();
				});
			},
			querySearch(queryString, cb) {
				this.searchForm.page = 1;
				const form = {
					title: queryString,
				};
				getcommunityList(form).then((res) => {
					const restaurants = res.data.records.map((item) => {
						return {
							value: item.title,
							id: item.id,
						};
					});
					const results = queryString ?
						restaurants.filter(this.createStateFilter(queryString)) :
						restaurants;
					cb(results);
				});
			},
			createStateFilter(queryString) {
				return (state) => {
					return (
						state.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
					);
				};
			},
			async handleSelect(e) {
				console.log(e);
				this.searchForm.xiaoqu_id = e;
				await this.searchChange();
			},
			uploadXiaoquHandleSelect(e) {
				this.uploadXiaoquId = e;
			},
			// 选择车位
			colorChange(e) {
				const matchedColor = this.colorArr.find(
					(color) => color.name === e.title
				);
				e.color = matchedColor.color;
			},
			submitFormz() {
				if (this.$refs.imgUpload.faData.url) {
					if (this.imgIf == true) {
						this.$refs.imgUpload.findTrue();

						this.imageUrl = this.$refs.imgUpload.faData.url;
					} else if (this.imgIf1 == true) {
						this.$refs.imgUpload.findTrue();

						this.setImageUrl = this.$refs.imgUpload.faData.url;
						this.chooseImg2(this.imgRes, this.setImageUrl);
					} else if (this.imgIf4 == true) {
						this.$refs.imgUpload.findTrue();

						this.setImageUrl = this.$refs.imgUpload.faData.url;
						this.chooseFirstimg(this.imgRes4, this.setImageUrl);
					} else if (this.imgIf2 == true) {
						this.$refs.imgUpload.findTrue();

						this.setImageUrl = this.$refs.imgUpload.faData.url;
						this.chooseImg3(this.imgRes2, this.setImageUrl);
					} else if (this.imgIf3 == true) {
						this.$refs.imgUpload.findTrue();

						this.setImageUrl = this.$refs.imgUpload.faData.url;

						this.chooseImg4(this.imgRes3, this.setImageUrl);
					}
					this.$refs.imgUpload.faData.url = "";
					this.$refs.imgUpload.getimgLists();
					this.upImg = false;
				} else {
					this.$message.warning("请选择一张照片");
				}
			},
			chooseFirstimg(res, req) {
				this.imgRes4 = res;
				if (req) {
					res.source_image = req;
				}
				this.imgIf = false;
				this.imgIf2 = false;
				this.imgIf1 = false;
				this.imgIf3 = false;
				this.imgIf4 = true;

				this.upImg = true;
			},
			// 选择图片
			chooseImg() {
				this.imgIf1 = false;
				this.imgIf2 = false;
				this.imgIf = true;
				this.imgIf3 = false;
				this.upImg = true;
				this.imgIf4 = false;
			},
			chooseImg2(res, req) {
				this.imgRes = res;
				if (req) {
					res.thumb = req;
				}
				this.imgIf = false;
				this.imgIf2 = false;
				this.imgIf1 = true;
				this.imgIf3 = false;
				this.imgIf4 = false;

				this.upImg = true;
			},
			chooseImg3(res, req) {
				this.imgRes2 = res;
				if (req) {
					res.img = req;
				}
				this.imgIf = false;
				this.imgIf1 = false;
				this.imgIf2 = true;
				this.imgIf3 = false;
				this.upImg = true;
				this.imgIf4 = false;
			},
			chooseImg4(res, req) {
				this.imgRes3 = res;
				if (req) {
					res.thumbnail = req;
				}
				this.imgIf = false;
				this.imgIf1 = false;
				this.imgIf2 = false;
				this.imgIf3 = true;
				this.upImg = true;
				this.imgIf4 = false;
			},
			searchNamechange() {
				this.cardTitle = "";
				this.searchChange();
			},
			// 清空
			clearInput() {
				this.searchForm.xiaoqu_id = undefined;
				this.cardTitle = "";
				this.initList();
			},
			clearInput2() {
				this.state = undefined;
				this.searchForm.xiaoqu_id = undefined;
				this.initList();
			},
			clearInput3() {
				this.uploadXiaoquId = null;
			},
			searchChanges() {
				this.searchChange();
				const selectedOption = this.regionArr.find(
					(item) => item.id === this.searchForm.xiaoqu_id
				);
				this.cardTitle = selectedOption.title;
				// 输出相同项
			},
			// 删除分区图片
			removeArea(res, req, ret) {
				ret.img = "";
				this.$forceUpdate();
			},
			// 删除源图
			removeFirstThumb(res) {
				res.source_image = "";
				this.$forceUpdate();
			},
			// 删除楼层图片
			removePicThumb(res) {
				res.thumb = "";
				this.$forceUpdate();
			},
			removeMinThumb(res) {
				res.thumbnail = "";
				this.$forceUpdate();
			},
			// 移除图片
			removePic() {
				this.imgDis = false;
				this.imageUrl = "";
				this.dialogData.carpark_img = "";
			},
			// 车位管理
			handCar(res) {
				this.$router.push({
					path: "/garage/parking",
					query: {
						id: res.id
					},
				});
			},
			// 图片
			handleAvatarSuccess(res, file) {
				this.imageUrl = res.data.path;
				this.dialogData.carpark_img = this.imageUrl;
				this.$forceUpdate(); // 强制更新视图
			},
			// 源图
			handleFirstSuccess(res) {
				return (response, file, fileList) => {
					// 处理上传成功逻辑
					res.source_image = file.response.data.path;
					this.$forceUpdate(); // 强制更新视图
				};
			},
			// 上传图片后刷新
			delayRefesh() {
				if (this.dialogType == "edit") {
					this.tabPick = "carList";
					this.imageUrl = "";
					this.imageUrl = this.floorRefeshData.carpark_img;
					if (this.imageUrl) {
						this.imgDis = true;
					}
					if (this.$refs.imgUpload) {
						this.$refs.imgUpload.faData.url = "";
					}
					// 先处理详情
					getFloor(this.floorRefeshData.id).then((req) => {
						console.log(req);
						this.dialogData = JSON.parse(JSON.stringify(req.data));
						console.log(this.dialogData);
						var lastItem = this.dialogData.floor.slice(-1)[0];
						var lastItemId = lastItem.id;
						if (this.modelId > 0) {
							this.tabPick = this.modelId.toString();
						} else {
							this.tabPick = lastItemId.toString();
						}
						const {
							carpark_img,
							content,
							floor,
							title,
							sort,
							total_num,
							xiaoqu_id,
							id,
						} = this.dialogData;

						const newData = {
							carpark_img,
							content,
							floors: floor,
							title,
							sort,
							total_num,
							xiaoqu_id,
							carpark_id: id,
						};
						this.dialogData = newData;

						// 再处理楼层数据
						this.dialogData.floors = this.dialogData.floors.map((item) => {
							const {
								id,
								city_id,
								region_id,
								xiaoqu_id,
								carpark_id,
								created_at,
								area,
								...rest
							} = item;
							const modifiedAreaData = item.area.map(
								({
									region_id,
									title,
									sort,
									img,
									id
								}) => ({
									area_id: id,
									title,
									sort,
									img,
									id,
								})
							);
							return {
								...rest,
								floor_id: id,
								title: item.title,
								thumb: item.thumb,
								color_tip: item.color_tip,
								sort: item.sort,
								vr_url: item.vr_url,
								areas: modifiedAreaData,
							};
						});
					});
					console.log(1);
				} else if (this.dialogType == "add") {
					console.log(2);
				}
			},
			// 分区图
			handleRegionSuccess(res) {
				return (response, file, fileList) => {
					// 处理上传成功逻辑
					res.img = file.response.data.path;
					this.$forceUpdate(); // 强制更新视图
				};
			},
			// 楼层图
			handleFloorSuccess(res) {
				return (response, file, fileList) => {
					// 处理上传成功逻辑
					res.thumb = file.response.data.path;
					this.$forceUpdate(); // 强制更新视图
				};
			},
			// 缩略图
			handleMinSuccess(res) {
				return (response, file, fileList) => {
					// 处理上传成功逻辑
					res.thumbnail = file.response.data.path;
					this.$forceUpdate(); // 强制更新视图
				};
			},
			beforeAvatarUploads(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 1;

				if (!isJPG) {
					this.$message.error("上传图片只能是 JPG 格式!");
				}

				return isJPG;
			},
			beforeAvatarUpload(file) {
				const isJPG =
					file.type === "image/jpeg" ||
					file.type === "image/png" ||
					file.type === "image/jpeg" ||
					file.type === "image/webp";
				const isLt2M = file.size / 1024 / 1024 < 1;

				if (!isJPG) {
					this.$message.error("上传图片只能是 JPG 格式!");
				}
				if (!isLt2M) {
					this.$message.error("上传图片只能是1M以下");
				}
				return isJPG && isLt2M;
			},
			// 选择小区
			getcommunityLists() {
				const form = {
					select: 1,
				};
				getcommunityList(form).then((res) => {
					this.regionList = res.data.records;
				});
			},
			// 添加车库
			handleNewAdd() {
				this.dialogType = "add";
				this.tabPick = "carList";
				this.dialogVisible = true;
				this.imageUrl = "";
				this.dialogData = {
					floors: [], // 初始化floors字段为空数组
				};
			},
			// 添加分区
			addArea(res) {
				if (res.areas === null) {
					// res.color_tip = [];
					this.$set(res, "areas", []);
				}
				res.areas.push({
					title: "",
					sort: "",
				});
			},
			// 添加车位类型
			addCarType(res) {
				if (res.color_tip === null) {
					// res.color_tip = [];
					this.$set(res, "color_tip", []);
				}
				res.color_tip.push({
					title: "",
					color: "",
				});
			},
			// 删除车位类型
			removeItem(res, index) {
				res.color_tip.splice(index, 1);
			},
			// 删除分区
			deleteArea(res, index, req) {
				res.areas.splice(index, 1);
				if (!req.id || req.id == undefined) {
					return;
				}
				deletearea(req.id).then((res) => {
					if (res.code == 200) return this.$message.success("删除成功!");
					this.$message.warning("不允许删除");
				});
			},
			// 弹窗关闭
			getout() {
				this.dialogVisible = false;
				this.drawFloor = false;
			},
			// 点击修改按钮
			updateMsg(res) {
				this.floorRefeshData = res;
				this.tabPick = "carList";
				this.dialogType = "edit";
				this.imageUrl = "";
				this.imageUrl = res.carpark_img;
				if (this.imageUrl) {
					this.imgDis = true;
				}
				if (this.$refs.imgUpload) {
					this.$refs.imgUpload.faData.url = "";
				}
				// 先处理详情
				getFloor(res.id).then((req) => {
					this.dialogData = req.data;
					const {
						carpark_img,
						content,
						floor,
						title,
						sort,
						total_num,
						xiaoqu_id,
						id,
					} = this.dialogData;

					const newData = {
						carpark_img,
						content,
						floors: floor,
						title,
						sort,
						total_num,
						xiaoqu_id,
						carpark_id: id,
					};
					this.dialogData = newData;

					// 再处理楼层数据
					this.dialogData.floors = this.dialogData.floors.map((item) => {
						const {
							id,
							city_id,
							region_id,
							xiaoqu_id,
							carpark_id,
							created_at,
							area,
							...rest
						} = item;
						const modifiedAreaData = item.area.map(
							({
								region_id,
								title,
								sort,
								img,
								id
							}) => ({
								area_id: id,
								title,
								sort,
								img,
								id,
							})
						);
						return {
							...rest,
							floor_id: id,
							title: item.title,
							thumb: item.thumb,
							color_tip: item.color_tip,
							sort: item.sort,
							vr_url: item.vr_url,
							areas: modifiedAreaData,
						};
					});
				});

				this.dialogVisible = true;
				// 点击修改时请求详情
			},
			// 关闭按钮
			handleClose() {},
			// 确定按钮
			submitForms() {
				const deleteNegativeValues = (data) => {
					if (Array.isArray(data)) {
						return data
							.map((item) => deleteNegativeValues(item))
							.filter((item) => item !== null);
					} else if (typeof data === "object" && data !== null) {
						const updatedData = {
							...data
						};
						Object.keys(updatedData).forEach((key) => {
							const value = updatedData[key];
							if (typeof value === "number" && value < 0) {
								delete updatedData[key];
							} else if (typeof value === "object") {
								updatedData[key] = deleteNegativeValues(value);
							}
						});
						return Object.keys(updatedData).length > 0 ? updatedData : null;
					}
					return data;
				};
				const filteredData = deleteNegativeValues(this.dialogData);
				if (this.imageUrl) {
					filteredData.carpark_img = this.imageUrl;
				}
				if (
					!filteredData.hasOwnProperty("title") ||
					!filteredData.hasOwnProperty("total_num")
				) {
					this.$message.warning("必填信息不完整,请仔细核对补充完整！！");
				} else {
					editCarList(filteredData).then((res) => {
						if (res.code !== 200) return this.$message.error("操作失败!");
						this.$message.success("操作成功");
						this.initList();
						this.dialogVisible = false;
					});
				}
				// 在这里继续处理过滤后的数据
			},
			// 添加选项卡
			addFloor() {
				const newFloor = {
					id: -(Math.random() * 1000).toFixed(0), // 使用负数作为id，确保唯一性
					floor_id: -(Math.random() * 1000).toFixed(0),
					title: "新楼层", // 新选项卡的标题
					areas: [], // 新选项卡的内容，可以根据需求进行初始化
					color_tip: [],
					lock_btn_show: 1,
				};
				this.dialogData.floors.push(newFloor); // 添加新选项卡到dialogData.floor
			},
			// 搜索重置
			resets() {
				this.searchForm = {
					page: 1,
					pageSize: 15,
					title: undefined,
				};
				this.initList();
				this.cardTitle = "";
			},
			// 移除选项卡
			removeTab(tabName) {
				if (tabName !== "车库详情") {
					// 通过tabName来判断是否是动态选项卡，而不是车库详情的选项卡
					const index = this.dialogData.floors.findIndex((floor) => {
						const idToCompare =
							this.dialogType == "add" ?
							String(floor.id) :
							String(floor.floor_id);
						return idToCompare === tabName;
					});
					if (parseInt(tabName) < 0) {
						this.$confirm("确定删除吗？", "删除", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(async () => {
							this.dialogData.floors.splice(index, 1); // 从dialogData.floor中移除选项卡数据
							this.$message.success("删除成功");
							this.tabPick = "carList";
						});
					} else {
						this.$confirm("确定删除吗？", "删除", {
							confirmButtonText: "确定",
							cancelButtonText: "取消",
							type: "warning",
						}).then(async () => {
							const res = await deletefloor(tabName);
							if (res.code !== 200) return this.$message.error("删除失败!");
							this.$message.success("删除成功");
							this.dialogData.floors.splice(index, 1); // 从dialogData.floor中移除选项卡数据
							this.tabPick = "carList";
						});
					}
				}
			},
		},
	};
</script>
<style scoped>
	/deep/ .dialogHeight .el-dialog__body {
		overflow: hidden;
	}

	.upload-container {
		display: flex;
		justify-content: center;
		align-items: center;
	}

	/deep/ .el-upload {
		width: 100%;
	}

	/deep/ .el-upload .el-upload-dragger {
		width: 100%;
	}

	.chooseImg {
		display: flex;
		align-items: center;
	}

	/deep/.el-table,
	.el-table th,
	.el-table td {
		border-radius: 10px;
		-webkit-font-smoothing: antialiased;
		text-rendering: optimizeLegibility;
		font-size: 16px;
		font-family: Times, "Times New Roman";
		/* font-weight: 600; */
	}

	.topNav {
		display: flex;
		align-items: center;
		justify-content: space-between;
		background: #fff;
		padding: 20px 20px;
		border-radius: 10px;
	}

	.navFormWrapper {
		display: flex;
		align-items: center;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #409eff;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 150px;
		height: 150px;
		line-height: 150px;
		text-align: center;
		border: 1px solid #dcdfe6;
	}

	.avatar-wrapper .el-icon-close {
		position: absolute;
		top: 5px;
		right: 5px;
		font-size: 18px;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.5);
		padding: 5px;
		border-radius: 50%;
		cursor: pointer;
	}

	.avatar {
		width: 150px;
		height: 150px;
		display: block;
	}

	.avatar-wrapper {
		position: relative;
	}

	.el-icon-close {
		position: absolute;
		top: 0;
		right: 55vh;
		cursor: pointer;
	}

	.el-icon-close:hover {
		color: #409eff;
	}

	/deep/ .el-dialog__body {
		height: 62vh;
		overflow-y: auto;
	}

	/deep/ .drawDialog .el-dialog__body {
		height: 20vh !important;
	}

	.card-container {
		width: fit-content;
		/* 将容器宽度设置为内容适应的宽度 */
		margin: 1.5vh 0 0 0;
		color: #409eff;
		/* 设置文本颜色 */
		font-size: 18px;
		/* 设置文本尺寸 */
		margin-left: 2px;
	}

	.auto-width-card {
		display: inline-block;
		/* 让卡片按照内容自适应宽度 */
	}
</style>


// WEBPACK FOOTER //
// src/views/garage/index.vue